
module.cC({
    name: 'FollowupPageController',
    inject: ['$scope', 'student', 'followups', 'verifications', 'ModelService'],

    data: {
        followups: 'followups',

        educationPlacements: "followups.education_placements",
        jobPlacements: "followups.jobs",
        profile: 'followups.profile',
        cj: 'followups.criminal_justice',
        verifications: 'verifications',
    },

    listen: {
        verification: {
            create: function(id, ownerId) {
                if (ownerId === this.student.id) {
                    this.ModelService.get('verification', id)
                        .then(this.ModelService.appendToArray(this.verifications));
                }
            },
            delete: function(id) {
                this.ModelService.removeById('verification', id, this.verifications);
            },
        }
    },
});
